import {Base,Axios} from "@/api/Base"

export class EmployeeExport extends Base {
    path = "employee/export"
    download(param = {}) {
        return Axios.get(this.path,{ params: param, responseType: "blob" })
    }
}